// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Zd2OZ","title-container":"classes_title-container__lbgWH","button":"classes_button__Pw2uI"};